/**
 * Composition methods for the endpoint view
 * 
 * Author: Andrea López <andrea.lopez@huumun.com>
 */
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export function endpointHeaderComposition () {
    const route = useRoute();
    const router = useRouter();

	// Computed properties
    const endpointId = computed((): string => route.params.endpointId as string);

    // Navigate function
    function navigateTo (path: string) {
        if (path === '') {
			router.go(-1);
        } else {
            router.push(path);
        }
    }

    return { endpointId, navigateTo }
}
